import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images//home//building.png';

const _withScopeId = n => (_pushScopeId("data-v-92621932"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "提示", -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip-content"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "tip-image",
  alt: ""
}), /*#__PURE__*/_createElementVNode("span", {
  class: "tip-text"
}, "功能正在开发中，敬请期待。")], -1));

const _hoisted_3 = {
  class: "dialog-footer"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("我知道了");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  const _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $props.show,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $props.show = $event),
    width: 560,
    "custom-class": "tip-dialog",
    "before-close": $options.closeDialog,
    "append-to-body": ""
  }, {
    title: _withCtx(() => [_hoisted_1]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
      type: "primary",
      class: "btn",
      onClick: $options.closeDialog
    }, {
      default: _withCtx(() => [_hoisted_4]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["modelValue", "before-close"]);
}